import { ACCENT, illustrationA11y, lineStyle } from './static-art';

const OLIVE = '#B0B86A';

export function ReviewIllustration(props: { className?: string; label?: string; ink?: string }) {
	const line = lineStyle(props.ink ?? OLIVE, 1.5);
	return (
		<svg
			width="159"
			height="164"
			viewBox="0 0 159 164"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path d="M105.2 109.777L113.508 118.084L117.827 113.93L109.512 105.441L105.2 109.777Z" {...line} />
			<path
				d="M110.567 120.984L120.709 111.439C120.709 111.439 165.301 144.168 156.862 154.414C148.108 165.041 110.567 120.984 110.567 120.984Z"
				{...line}
			/>
			<path
				d="M6.31641 67.6041C6.31641 99.877 25.9359 126.496 64.7526 126.04C97.023 125.662 123.189 99.877 123.189 67.6041C123.189 35.3313 97.0254 9.16797 64.7526 9.16797C32.4797 9.16797 6.31641 35.3313 6.31641 67.6041Z"
				{...line}
			/>
			<path
				d="M22.1072 77.1009C30.1602 68.2714 63.8768 36.8381 107.204 74.2936C108.374 75.3054 108.475 77.0815 107.43 78.2195C99.4567 86.9034 66.0847 117.742 22.3692 81.0437C21.1755 80.0417 21.059 78.2486 22.1072 77.0985V77.1009Z"
				{...line}
			/>
			<path
				d="M64.7536 94.2938C73.9033 94.2938 81.3207 86.8765 81.3207 77.7267C81.3207 68.577 73.9033 61.1596 64.7536 61.1596C55.6038 61.1596 48.1865 68.577 48.1865 77.7267C48.1865 86.8765 55.6038 94.2938 64.7536 94.2938Z"
				{...line}
			/>
			<path
				d="M17.3377 54.3782L25.9367 64.268"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M112.168 54.3782L103.569 64.268"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M28.703 38.2986L38.6753 56.3555"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M99.8628 38.2986L89.8905 56.3555"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M47.6423 30.7917L52.1868 51.4884"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M82.2959 31.277L77.0235 51.7311"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path d="M64.8183 29.0252V50.593" stroke={ACCENT} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
		</svg>
	);
}
